import { Component, Input } from '@angular/core';

@Component({
  selector: 'rmt-initials',
  templateUrl: 'rmt-initials.html'
})
export class RmtInitialsComponent {
  @Input() color: string = 'blue';
  
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-initials/rmt-initials.ts